import React, { useEffect, useRef, useState, useCallback } from "react";
import io from "socket.io-client";
import { Button, CircularProgress, Grid } from "@mui/material";
import captureVideoFrame from "capture-video-frame";

import DrawingBoard from "./DrawingBoard";

const Room = React.memo((props) => {
  const { conf, onClose, OnError } = props;
  const audioCall = conf.audio;
  const videoCall = conf.video;

  //to modify video and audio bitrate(for bandwidth restriction)
  const videoBit = 1000;
  const audioBit = 50;

  // my video ref (engineer/customer)
  const userVideo = useRef();
  const audioElement = useRef(null);
  // other person video ref
  const partnerVideo = useRef();
  //RTC peer connection ref
  const peerRef = useRef();
  //socket ref
  const socketRef = useRef();
  //just to have track of other user
  //const otherUser = useRef();
  //to have the media stream ref
  const userStream = useRef();
  //this is used on for engineer and to have annotation
  const drawingBoard = useRef();
  //to store the roomID
  const roomId = useRef();
  //datachannel ref
  const dataChannel = useRef();
  //the mobile device dimensions
  const [dim, setDim] = useState();
  //start webrtc only after getting userMedia
  const [permissionGranted, SetpermissionGranted] = useState(false);
  const [callStarted, setCallStarted] = useState(false);
  const [gettingCall, setGettingCall] = useState(false);
  const fromNetworkStatus = useRef(false);
  const [statusText, setStatusText] = useState("Waiting...");
  // to store canvas dim, roomid and type of call
  const [args, setArgs] = useState();
  // to pause video
  const [paused, setPaused] = useState(false);
  //for engineer to store the customer is having video or audio call
  const [callType, setCallType] = useState(videoCall ? "video" : "audio");
  //to mute the stream
  const [mute, setMute] = useState(false);
  // track data channel state to re-render DrawingBoard with latest ref
  const [dcReady, setDcReady] = useState(false);
  const [pausevideotext, SetPauseVideotext] = useState("Please pause the video and annotate");

  //to see if the react application is opend in mobile or desktop
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  var mediaConstraints = {};

  useEffect(() => {
    //add required constraints
    if (audioCall) {
      mediaConstraints["audio"] = {
        autoGainControl: true,
        //stereo
        channelCount: 2,
        echoCancellation: true,
        noiseSuppression: true,
        //frequency for audio (8000/16000 for desktop, can be higher for phones)
        sampleRate: 8000,
        sampleSize: 16,
      };
      mediaConstraints["video"] = false;
    }
    if (videoCall) {
      mediaConstraints["video"] = {
        width: window.innerHeight,
        height: window.innerWidth,
      };
    } else {
      mediaConstraints["video"] = false;
    }
    if (isMobile) {
      if (videoCall) {
        mediaConstraints["video"]["facingMode"] = {
          exact: "environment",
        };
      }
    }
    //get user media
    navigator.mediaDevices
      .getUserMedia(mediaConstraints)
      .then((stream) => {
        userVideo.current.srcObject = stream;
        userStream.current = stream;
        SetpermissionGranted(true);
      })
      .catch((e) => {
        SetpermissionGranted(false);
        disconnect();
        handelDisconnect();
        OnError(e);
      });
  }, []);

  useEffect(() => {
    if (permissionGranted) {
      //connect to socket server
      socketRef.current = io(conf.socketIoPath);
      //automatic listener for disconnection of socket from server
      socketRef.current.on("connect_error", (err) => {
        disconnect();
        handelDisconnect();
        alert("you are not authorized");
        console.log(err.message); // not authorized
        console.log(err.data); // { content: "Please retry later" }
      });
      roomId.current = conf.roomId; //once customer sends join
      //customer will receive user joined

      //engineer will receive other user
      socketRef.current.on("connnection established", (args) => {
        //create room will allow engineer to wait in room
        console.log(
          "connection established-sending mail",
          conf.roomId,
          // conf.targetEmail,
          // conf.targetContactNumber
        );
        socketRef.current.emit("create room", {
          roomId: conf.roomId,
          // emailId: conf.targetEmail,
          // contactnumberId: conf.targetContactNumber,
        });
      });
      AddListeners();
      //some UI changes based on the video dimensions
      userVideo.current.height = window.innerHeight;
      userVideo.current.width = window.innerWidth;
      let top =
        document.getElementById("parentElement").getBoundingClientRect().top +
        "px";
      userVideo.current.style.top = top;
      partnerVideo.current.style.top = top;
    }
  }, [permissionGranted]);

  useEffect(() => {
    if (callType === "video") {
      let top =
        document.getElementById("parentElement").getBoundingClientRect().top +
        "px";
      let canvas = document.getElementById("my-canvas").style;
      canvas.top = top;
      canvas.left = partnerVideo.current.getBoundingClientRect().left + "px";
    }
  }, [callStarted]);

  const AddListeners = () => {
    socketRef.current.on("other user", (args) => {
      console.log("received");
      if (fromNetworkStatus.current) {
        setStatusText("");
        setGettingCall(false);
        socketRef.current.emit("callReceived", { roomId: conf.roomId });
        callUser(args.roomId);
        setDim(args.canvasDim);
        setCallType(args.type);
      } else {
        setGettingCall(true);
        setStatusText(`Getting a ${args.type} call...`);

        setArgs(args);
      }
    });

    socketRef.current.on("error occured", (args) => {
      alert(args.message);
      handelDisconnect();
    });
    //whenever answer is received at engineer's end
    socketRef.current.on("answer", handleAnswer);
    //on ice candidate exchange event
    socketRef.current.on("ice-candidate", handleNewICECandidateMsg);
    //whenever any one cliks on disconnect button
    socketRef.current.on("callDisconnect", handelDisconnect);
  };
  const pauseCB = useCallback(() => {
    const img = document.getElementById("my-canvas");
    img
      .getContext("2d")
      .clearRect(
        0,
        0,
        img.getBoundingClientRect().width,
        img.getBoundingClientRect().height
      );
    if (img.style.backgroundImage !== "") {
      setPaused(false);
      img.style.backgroundImage = "";
    } else {
      setPaused(true);
      const frame = captureVideoFrame(
        isMobile ? "userVideo" : "partnerVideo",
        "png"
      );
      img.style.backgroundImage = `url(${frame.dataUri})`;
    


      
    }
  }, [paused, dim]);

  const handelNetworkIssue = () => {
    fromNetworkStatus.current = true;
    setGettingCall(false);
    setCallStarted(false);
    setDcReady(false);

    setStatusText("Reconnecting Please Wait...");
    if (peerRef.current) {

      peerRef.current.close();

      peerRef.current = undefined;
    }
  };
  const receiveCall = () => {
    setStatusText("");
    setGettingCall(false);
    //notify call received
    socketRef.current.emit("callReceived", { roomId: conf.roomId });
    //Engineer will initiate the call
    callUser(args.roomId);
    //setting dimension based on customer screen
    setDim(args.canvasDim);

    setCallType(args.type);
  };
  const rejectCall = () => {
    setGettingCall(false);
    setStatusText("Waiting...");
    socketRef.current.emit("callRejected", { roomId: conf.roomId });
    if (socketRef.current) socketRef.current.close();
    if (peerRef.current) peerRef.current.close();
    onClose();
  };
  const callUser = (roomId) => {
    //this will create the RTC Peer connection
    peerRef.current = CreatePeer(roomId);
    userStream.current.getTracks().forEach((track) => {
      peerRef.current.addTrack(track, userStream.current);
    });
  };
  const CreatePeer = (roomId) => {
    //create peer connection
    const peer = new RTCPeerConnection({
      iceServers: conf.iceServers,
    });
    //create datachannal
    dataChannel.current = peer.createDataChannel("ch");
    //have required handlers for datachannal (open,close,message,error)
    configDC(dataChannel.current);
    //handle on Ice candidate event
    peer.onicecandidate = handleICECandidateEvent;

    peer.onconnectionstatechange = handelConnectionChange;

    //handle on ontrack  event
    peer.ontrack = handleTrackEvent;
    peer.onnegotiationneeded = () => handelNegotiationNeededEvent(roomId);
    // on datachannal event
    peer.ondatachannel = handelOnDataChannel;
    return peer;
  };
  const handelConnectionChange = (e) => {
    if (
      e.currentTarget.connectionState === "disconnected" ||
      e.currentTarget.connectionState === "closed"
    ) {
      handelNetworkIssue();
    }
  };
  const handelOnDataChannel = (e) => {
    //save the ref in datachannal
    console.log(e.channel);
    dataChannel.current = e.channel;
    configDC(dataChannel.current);
    setDcReady(true);
  };
  const configDC = (dataChannel) => {
    //this is self explainatory
    dataChannel.onopen = handelOnDataChannelOpen;
    dataChannel.onclose = handelOnDataChannelClose;
    dataChannel.onmessage = handelOnDataChannelMessage;
    dataChannel.onerror = handelOnDataChannelError;
  };
  const handelOnDataChannelOpen = (e) => {
    // console.log('open', e)
    // alert('Hi')
    console.log("Datachannel state is", dataChannel.current.readyState);
    setDcReady(true);
  };
  const handelOnDataChannelClose = (e) => {
    // console.log('close', e)
  };
  const handelOnDataChannelError = (e) => {
    // console.log('error', e)
  };
  const handelOnDataChannelMessage = (args) => {
    let data = JSON.parse(args.data);
    // console.log("the data is", data);
    if (data.type === "mute") {
      //here this event will receive only when enginner send mute
      //so here the partner audio will be muted
      partnerVideo.current.muted = data.muteValue;
    } else if (data.type === "pause") {
      //here this event will receive only when enginner send mute
      //here the video will be paused as there is only customer video
      pauseCB();
    } else drawingBoard.current.getData(args.data);
  };
  const addBitRate = (sdp, media, bitRate) => {
    let lines = sdp.split("\n");
    let lineIndex = -1;
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      if (line.indexOf("m=" + media) === 0) {
        lineIndex = i;
        break;
      }
    }
    lines.splice(lineIndex + 2, 0, "b=AS:" + bitRate);
    let finalSDP = "";
    lines.map((c, index) => {
      if (index !== lines.length - 1) {
        finalSDP += c + "\n";
      } else {
        finalSDP += c;
      }
    });
    return finalSDP;
  };
  const handelNegotiationNeededEvent = (roomId) => {
    //here the offer is created
    //setting up of localDescription
    //send offer to other peer via socket
    peerRef.current
      .createOffer({ iceRestart: true })
      .then((offer) => {
        //session description protocol
        offer.sdp = addBitRate(offer.sdp, "video", videoBit);
        offer.sdp = addBitRate(offer.sdp, "audio", audioBit);
        // console.log(offer.sdp)
        return peerRef.current.setLocalDescription(offer);
      })
      .then(() => {
        // console.log(peerRef.current.localDescription.sdp)
        const payload = {
          roomId: roomId,
          sdp: peerRef.current.localDescription,
        };
        console.log(payload);
        console.log(roomId);
        socketRef.current.emit("offer", payload);
      })
      .catch((e) => console.log(e));
  };
  const handleAnswer = (message) => {
    // set remote description based on the answer received
    fromNetworkStatus.current = false;
    const desc = new RTCSessionDescription(message.sdp);
    peerRef.current
      .setRemoteDescription(desc)
      .then((res) => {
        setCallStarted(true);
        setMute(false);
        setPaused(false);
      })
      .catch((e) => console.log(e));
  };
  const handleICECandidateEvent = (e) => {
    console.log(e.candidate);
    console.log(roomId.current);
    if (e.candidate) {
      const payload = {
        roomId: roomId.current,
        candidate: e.candidate,
      };
      socketRef.current.emit("ice-candidate", payload);
    }
  };
  const handleNewICECandidateMsg = (incoming) => {
    const candidate = new RTCIceCandidate(incoming.candidate);
    peerRef.current
      .addIceCandidate(candidate)
      .catch((e) => console.log("from ", e));
  };
  const handleTrackEvent = (e) => {
    partnerVideo.current.srcObject = e.streams[0];
  };
  // whenever anyonce clicks on the disconnect disconnect peer and socket
  const handelDisconnect = () => {
    if (socketRef.current) socketRef.current.close();
    if (peerRef.current) peerRef.current.close();
    onClose();
  };
  //when any one clicks on the button then emit that to server intern to user in the room
  const disconnect = () => {
    if (socketRef.current)
      socketRef.current.emit("disconnectCall", { roomId: roomId.current });
  };
  const muteVideo = (args) => {
    if (dataChannel.current && dataChannel.current.readyState === "open") {
      dataChannel.current.send(
        JSON.stringify({ type: "mute", muteValue: args })
      );
      setMute(args);
    }
  };

  const displaypausetext = () =>{
    document.getElementById("pausetext").style.display="block";
    console.log("displaying.....")
  }

  useEffect(() => {
    const partnerVideoElement = document.getElementById("partnerVideo");
    const canvasElement = document.getElementById("my-canvas");
    if (paused) {
      partnerVideoElement.style.visibility = "hidden";

      // Remove dynamically added top value while paused
      canvasElement.style.removeProperty("top");
    } else {
      partnerVideoElement.style.visibility = "visible";
    }
  }, [paused]);

  return (
    <>
      <Grid
        container
        style={{ height: "90svh", width: "100%" }}
        id="parentElement"
        justifyContent="center"
        alignItems="center"
        overflow="hidden"
      >
        <div
          style={{ display: callStarted ? "none" : "block", color: "white" }}
        >
          <CircularProgress
            style={{ display: gettingCall ? "none" : "block" }}
          />
          {statusText}
        </div>
        {gettingCall && (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            width="100%"
          >
            <Button
              style={{ margin: "10px", textTransform: "none" }}
              variant="contained"
              color="success"
              onClick={() => {
                receiveCall();
              }}
            >
              Receive
            </Button>
            <Button
              style={{ margin: "10px", textTransform: "none" }}
              variant="contained"
              color="error"
              onClick={() => {
                rejectCall();
              }}
            >
              Hang up
            </Button>
          </Grid>
        )}
        <>

        {/* <div
        style={{
          display:"flex",
          flexDirection:"column"
        }}>
        <h1 id="pausetext" style={{fontSize:"10px",
          display:"none",
          color:"white",
          position:"fixed",
          top:0,
          textAlign:"center"
          
        }}>{pausevideotext}</h1> */}
          <video
            autoPlay
            ref={partnerVideo}
            id="partnerVideo"
            width={dim ? dim.width * 0.7 : 0}
            height={dim ? dim.height * 0.7 : 0}
            style={{
              // marginTop:"20px",
              zIndex: 1,
              display:
                conf.isEngineer && callType === "video" && callStarted
                  ? "block"
                  : "none",
            }}
          />

          <video
            autoPlay
            ref={userVideo}
            id="userVideo"
            muted
            style={{
              zIndex: 2,
              width: "0px",
              height: "0px",
              display: "none",
            }}
          />
          </>
      

        <DrawingBoard
          ref={drawingBoard}
          isMobile={isMobile}
          dataChannel={dcReady ? dataChannel.current : null}
          disconnect={disconnect}
          callDimensions={
            conf.isEngineer
              ? dim
                ? {
                    width: dim.width * 0.7,
                    height: dim.height * 0.7,
                  }
                : {
                    width: 0,
                    height: 0,
                  }
              : {
                  width: window.innerWidth * 0.7,
                  height: window.innerHeight * 0.7,
                }
          }
          pause={paused}
          pauseCB={pauseCB}
          setPaused={setPaused}
          video={callType}
          callStarted={callStarted}
          rtc={peerRef.current}
          userStream={userStream.current}
          isengineer={conf.isEngineer}
          displaypausetext={displaypausetext}
          SetPauseVideotext={SetPauseVideotext}
          pausevideotext={pausevideotext}
        
        />
      </Grid>
    </>
  );
});
export default Room;
